import { makeStyles } from 'tss-react/mui';

const name = 'MultichainEndpoints';

export const useMultichainEndpointsStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    alignContent: 'center',
    justifyContent: 'center',
    gap: theme.spacing(7.5),

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
}));
